export default class CurrentPeriodDataManager {
  constructor() {
    this.savingsSummaryId = null;
    this.currentStartDate = null;
    this.currentEndDate = null;
    this.transactionDateRange = null;

    this.init();
  }

  init() {
    // Get savings summary ID from URL
    const pathParts = window.location.pathname.split('/');
    this.savingsSummaryId = pathParts[pathParts.length - 1];

    // Load current period data
    this.loadCurrentPeriodData();
  }

  updateDateRangeUI(data) {
    const startDateElement = document.getElementById('data-start-date');
    const endDateElement = document.getElementById('data-end-date');
    const transactionCountElement = document.getElementById('transaction-count');

    if (data.start_date && data.end_date) {
      startDateElement.textContent = this.formatDate(data.start_date);
      endDateElement.textContent = this.formatDate(data.end_date);
      transactionCountElement.textContent = data.transaction_count.toLocaleString();
    } else {
      startDateElement.textContent = 'No data';
      endDateElement.textContent = 'No data';
      transactionCountElement.textContent = '0';
    }
  }

  formatDate(dateString) {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
  }

  async loadCurrentPeriodData() {
    if (!this.savingsSummaryId) return;

    try {
      const params = new URLSearchParams();
      if (this.currentStartDate) params.append('start_date', this.currentStartDate);
      if (this.currentEndDate) params.append('end_date', this.currentEndDate);

      const response = await fetch(`/savings_summaries/${this.savingsSummaryId}/current_stats?${params}`);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      this.updateDateRangeUI(data)
      this.updateCurrentPeriodUI(data);

    } catch (error) {
      console.error('Error loading current period data:', error);
      this.showErrorState();
    }
  }

  updateCurrentPeriodUI(data) {
    // Update metric cards
    this.updateElement('current-diesel-gallons', this.formatNumber(data.diesel_gallons));
    this.updateElement('current-reefer-gallons', this.formatNumber(data.reefer_gallons));
    this.updateElement('current-def-gallons', this.formatNumber(data.def_gallons));
    this.updateElement('current-total-gallons', this.formatNumber(data.total_gallons));

    this.updateElement('current-avg-diesel-cost', this.formatCurrency(data.avg_diesel_cost));
    this.updateElement('current-avg-reefer-cost', this.formatCurrency(data.avg_reefer_cost));
    this.updateElement('current-avg-def-cost', this.formatCurrency(data.avg_def_cost));
    this.updateElement('current-weighted-avg-cost', this.formatCurrency(data.weighted_avg_cost));

    this.updateElement('current-avg-diesel-discount', this.formatCurrency(data.avg_diesel_discount));
    this.updateElement('current-avg-reefer-discount', this.formatCurrency(data.avg_reefer_discount));
    this.updateElement('current-avg-def-discount', this.formatCurrency(data.avg_def_discount));
    this.updateElement('current-total-discount', this.formatCurrency2Decimals(data.total_discount));
    this.updateElement('current-total-savings', this.formatCurrency2Decimals(data.total_savings));

    this.updateElement('current-in-network-gallons', this.formatNumber(data.in_network_gallons));
    this.updateElement('current-out-network-gallons', this.formatNumber(data.out_network_gallons));
    this.updateElement('current-network-rate', this.formatPercentage(data.network_rate));

    this.updateElement('current-total-fees', this.formatCurrency2Decimals(data.total_fees));
    this.updateElement('current-avg-fee-per-gallon', this.formatCurrency(data.avg_fee_per_gallon));
    this.updateElement('current-fee-rate', this.formatPercentage(data.fee_rate));

    this.updateElement('current-weighted-pump-fee', this.formatCurrency(data.weighted_pump_fee));
    this.updateElement('current-total-pump-fees', this.formatCurrency2Decimals(data.total_pump_fees));
    this.updateElement('current-pump-fee-rate', this.formatPercentage(data.pump_fee_rate));
  }

  updateElement(id, value) {
    const element = document.getElementById(id);
    if (element) {
      element.textContent = value;
    }
  }

  formatNumber(value) {
    if (value === null || value === undefined || isNaN(value)) return '-';
    return Number(value).toLocaleString('en-US', { maximumFractionDigits: 2 });
  }

  formatCurrency(value) {
    if (value === null || value === undefined || isNaN(value)) return '-';
    return '$' + Number(value).toLocaleString('en-US', { minimumFractionDigits: 3, maximumFractionDigits: 3 });
  }

  formatCurrency2Decimals(value) {
    if (value === null || value === undefined || isNaN(value)) return '-';
    return '$' + Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  formatPercentage(value) {
    if (value === null || value === undefined || isNaN(value)) return '-';
    return Number(value).toFixed(1) + '%';
  }

  showErrorState() {
    // Set all displays to error state
    const elements = [
      'current-diesel-gallons', 'current-reefer-gallons', 'current-def-gallons', 'current-total-gallons',
      'current-avg-diesel-cost', 'current-avg-reefer-cost', 'current-avg-def-cost', 'current-weighted-avg-cost',
      'current-avg-diesel-discount', 'current-avg-reefer-discount', 'current-avg-def-discount', 'current-total-discount', 'current-total-savings',
      'current-in-network-gallons', 'current-out-network-gallons', 'current-network-rate',
      'current-total-fees', 'current-avg-fee-per-gallon', 'current-fee-rate',
      'current-weighted-pump-fee', 'current-total-pump-fees', 'current-pump-fee-rate'
    ];

    elements.forEach(id => {
      this.updateElement(id, 'Error');
    });
  }
}
